/**
 * Generic Dashlet
 */
hrd.AbstractDashlet = hrd.AbstractCommonInterface.extend({
	dashboard: undefined, // reference of parent dashboard
	controls: {},
	init: function(panel, options) {
		// this.doMixin();
		this.dashboard = options.dashboard || dashboardInstance;
		delete options.dashboard;
		var defaults = {
			impl: 'hrd.AbstractDashlet',
			size: this.dashboard.isDoubleSize() ? '2x' : '1x'
		};
		this.panel = $(panel);
		this._super($.extend({}, defaults, options));
		this.doInit();
	},
	doInit: function() {
		var dashletInfo = this.panel.data('dashletInfo');
		this.panel.attr('id', this._toId('panel'));
		this.panel.children('.dashlet-header').attr('id', this._toId('header'));
		this.panel.children('.dashlet-content').attr('id', this._toId('content'));
		this.panel.children('.dashlet-footer').attr('id', this._toId('footer'));
		this.PANEL_ID = this._toIdSelector('panel');
		this.HEADER_ID = this._toIdSelector('header');
		this.CONTENT_ID = this._toIdSelector('content');
		this.CAPTION_ID = this._toIdSelector('table_caption');
		if (this.isInsideTab()) {
			this.TAB_MANAGER_ID = '#' + this.getTabManager().uniqueId().attr('id');
			var containerTab = this.getContainerTab();
			this.TAB_ID = '#' + containerTab.uniqueId().attr('id');
			// search for 'OUTER_TAB_ID'
			var outerContainerTab = containerTab.parent().closest('.dashlet-tab-pane');
			if (outerContainerTab.exists()) {
				this.OUTER_TAB_ID = '#' + outerContainerTab.uniqueId().attr('id');
			}
		}
		if (this.settings.size === '2x') {
			$(this.PANEL_ID).addClass('dashlet-2x');
		}
		if (dashletInfo && dashletInfo.options) {
			if (dashletInfo.options.hideHeader == true) {
				$(this.HEADER_ID).hide();
				this.panel.addClass('no-header');
			}
		}

		const backgroundPath = this.doBackground();

		if (backgroundPath) {
			$(this.PANEL_ID).get(0).style.setProperty('--background-image', `url(${backgroundPath})`);
		}
	},
	// doMixin: $.noop,
	doBackground: $.noop,
	doDashlet: $.noop,
	doActivated: $.noop,
	doResize: $.noop,
	emitting: $.noop,
	listening: $.noop,
	dashboardHasCompleted: $.noop,
	usingChromaFlow: function() {
		return $(this.PANEL_ID).usingChromaFlow();
	},
	isListeningTo: function(event) {
		return (this.listeningEvents.indexOf(event) != -1);
	},
	listeningAsList: function(event) {
		return this.listeningEvents.join(' ');
	},
	joinEvents: function() {
		var events = Array.prototype.slice.call(arguments, 0);
		return events.join(' ');
	},
	/* Make Content Droppable */
	makeDroppable: function(options, target) {
		options = $.extend({
			scope: 'empty',
			activeClass: 'ui-state-focus',
			hoverClass: 'ui-state-highlight'
		}, options);

		$(this.CONTENT_ID).droppable({
			scope: options.scope,
			activeClass: options.activeClass,
			hoverClass: options.hoverClass,
			drop: (_, ui) => $(ui.helper).data('droppable-deferred').resolve(target)
		});
	},
	/* utility methods */
	enablePanel: function() {
		$(this.PANEL_ID).waiting('done');
	},
	disablePanel: function() {
		$(this.PANEL_ID).waiting('disable');
	},
	waitingPanel: function() {
		$(this.PANEL_ID).waiting();
	},
	endWaitingPanel: function() {
		$(this.PANEL_ID).waiting('done');
	},
	disableContent: function() {
		$(this.CONTENT_ID).waiting('disable');
	},
	enableContent: function() {
		$(this.CONTENT_ID).waiting('done');
	},
	waitingContent: function() {
		$(this.CONTENT_ID).waiting();
	},
	endWaitingContent: function() {
		$(this.CONTENT_ID).waiting('done');
	},
	disableTab: function() {
		if (this.TAB_ID != undefined) {
			dashboardInstance.getTabById(this.TAB_ID).waiting('disable');
		}
	},
	enableTab: function() {
		if (this.TAB_ID != undefined) {
			dashboardInstance.getTabById(this.TAB_ID).waiting('done');
		}
	},
	toggleButtonVisibility: function($btn, toggle) {
		if (toggle) {
			this.showButton($btn);
		} else {
			this.hideButton($btn);
		}
	},
	showButton: function($btn) {
		if ($btn) {
			$btn.show();
		}
	},
	hideButton: function($btn) {
		if ($btn) {
			$btn.hide();
		}
	},
	toggleEnablementButton: function($btn, toggle) {
		if (toggle) {
			this.enableButton($btn);
		} else {
			this.disableButton($btn);
		}
	},
	enableButton: function($btn) {
		if ($btn) {
			$btn.button('enable');
		}
	},
	disableButton: function($btn) {
		if ($btn) {
			$btn.button('disable');
		}
	},
	getControl: function(control) {
		if (typeof control === 'string') {
			return this.controls[control];
		} else {
			return control;
		}
	},
	/**
	 * Toggles visibility of given control by name
	 *
	 */
	toggleControlVisibility: function(control, enable) {
		enable = (enable == undefined) ? true : enable;
		if (enable) {
			this.showControl(control);
		} else {
			this.hideControl(control);
		}
	},
	/**
	 * show given control by name
	 *
	 */
	showControl: function(control) {
		this.showButton(this.getControl(control));
	},
	/**
	 * hide given control by name
	 *
	 */
	hideControl: function(control) {
		this.hideButton(this.getControl(control));
	},
	toggleAllControls: function(enable, skip) {
		enable = (enable == undefined) ? true : enable;
		if (enable) {
			this.enableAllControls(skip);
		} else {
			this.disableAllControls(skip);
		}
	},
	/**
	 * Enable all dashlet header controls, skipping the ones present in the 'skip' argument
	 *
	 * @param skip: array of button names to be skipped
	 */
	enableAllControls: function(skip) {
		skip = skip || [];
		$.each(this.controls, function(btnName, $btn) {
			if (skip.indexOf(btnName) == -1) {
				this.enableButton($btn);
			}
		}.bind(this));
	},
	/**
	 * Disable all dashlet header controls, skipping the ones present in the 'skip' argument
	 *
	 * @param skip: array of button names to be skipped
	 */
	disableAllControls: function(skip) {
		skip = skip || [];
		$.each(this.controls, function(btnName, $btn) {
			if (skip.indexOf(btnName) == -1) {
				this.disableButton($btn);
			}
		}.bind(this));
	},
	/**
	 * Toggles given control by name
	 *
	 */
	toggleControl: function(control, enable) {
		enable = (enable == undefined) ? true : enable;
		if (enable) {
			this.enableControl(control);
		} else {
			this.disableControl(control);
		}
	},
	/**
	 * Enable given control by name
	 *
	 */
	enableControl: function(control) {
		if (typeof control === 'string') {
			this.enableButton(this.controls[control]);
		} else {
			this.enableButton(control);
		}
	},
	/**
	 * Disable given control by name
	 *
	 */
	disableControl: function(control) {
		if (typeof control === 'string') {
			this.disableButton(this.controls[control]);
		} else {
			this.disableButton(control);
		}
	},
	dispatcherMenuAction: function(action, itemAction, itemElement, extraArgs) {
		let actualActionToCall = $.functionCase(`${action}-${itemAction}`);
		let actionCommonArgs = $.functionCase(`${action}-common-args`);
		let commonArgsPromise;
		if (typeof this[actionCommonArgs] === 'function') {
			commonArgsPromise = $.when(this[actionCommonArgs].call(this));
		} else {
			commonArgsPromise = $.when({});
		}
		if (typeof this[actualActionToCall] === 'function') {
			commonArgsPromise.then(commonArgs => {
				commonArgs = $.extend(commonArgs, extraArgs);
				if (!commonArgs.stopExecution === true) {
					this[actualActionToCall].call(this, commonArgs, itemElement);
				}
			});
		} else {
			console.log(`The action "${actualActionToCall}" is not defined for dashlet "${this._FULL_}". Use "${actionCommonArgs}" if some specific arguments must be communicated to action`);
		}
	},
	isInsideTab: function() {
		return $(this.CONTENT_ID).closest('.dashlet-tab-pane').exists();
	},
	isInsideOuterTab: function() {
		let isInsideOuterTab = false;
		if (this.isInsideTab()) {
			var containerTab = this.getContainerTab();
			var outerContainerTab = containerTab.parent().closest('.dashlet-tab-pane');
			isInsideOuterTab = outerContainerTab.exists();
		}
		return isInsideOuterTab;
	},
	isInsideNotActiveTab: function() {
		return $(this.CONTENT_ID).closest('.dashlet-tab-pane:not(:visible)').exists();
	},
	getContainerTab: function() {
		return $(this.CONTENT_ID).closest('.dashlet-tab-pane');
	},
	getTabManager: function() {
		return $(this.CONTENT_ID).closest('.dashlet-tab');
	},
	isFirstTab: function() {
		let isFirstTab = false;
		var li = $(`ul.dashlet-tabs li a[href="${this.TAB_ID}"]`).closest('li');
		var ul = li.closest('ul');
		if (li.exists()) {
			var hasTabNav = ul.find('.tab__navigation').exists();
			var tabPosition = li.index() - (hasTabNav ? 1 : 0);
			isFirstTab = tabPosition === 0;
		} else {
			// not really inside a tab
			isFirstTab = false;
		}
		return isFirstTab;
	},
	setTitle: function(txt) {
		var $headerTitle = $(this.HEADER_ID).find('.ui-panel-title-text');
		if ($headerTitle.exists()) {
			var tableSizeBox = $headerTitle.find('.table-size-box');
			if (tableSizeBox.exists()) {
				tableSizeBox.detach();
			}
			if (this.originalHeader == undefined) {
				this.originalHeader = $headerTitle.text();
			}
			$headerTitle.html(txt);
			if (tableSizeBox.exists()) {
				$headerTitle.append(tableSizeBox);
			}
		}
	},
	appendTitle: function(txt, separator) {
		separator = separator == undefined ? ' - ' : separator;
		var $headerTitle = $(this.HEADER_ID).find('.ui-panel-title-text');
		if ($headerTitle.exists()) {
			var tableSizeBox = $headerTitle.find('.table-size-box');
			if (tableSizeBox.exists()) {
				tableSizeBox.detach();
			}
			if (this.originalHeader == undefined) {
				this.originalHeader = $headerTitle.text();
			}

			if (!txt) {
				$headerTitle.html(this.originalHeader);
			} else {
				$headerTitle.html(`${this.originalHeader}${separator}<span class="dashlet-header-dynamic-title">${txt}</span>`);
			}

			if (tableSizeBox.exists()) {
				$headerTitle.append(tableSizeBox);
			}
		}
	},
	resetTitle: function() {
		var $headerTitle = $(this.HEADER_ID).find('.ui-panel-title-text');
		if ($headerTitle.exists()) {
			var tableSizeBox = $headerTitle.find('.table-size-box');
			if (tableSizeBox.exists()) {
				tableSizeBox.detach();
			}
			$headerTitle.html(this.originalHeader);
			if (tableSizeBox.exists()) {
				$headerTitle.append(tableSizeBox);
			}
		}
	},
	setCaption: function(txt) {
		var $captionTitle = $(this.CAPTION_ID).find('label.table-caption-label');
		$($captionTitle).html(txt);
	},
	openMedia: function(evt, btn) {
		var videoInfo = $(btn).data('videoInfo');
		if (videoInfo == undefined) {
			if ($(btn).data('video')) {
				videoInfo = $.evaluate($(btn).data('video'));
				videoInfo.type = videoInfo.type || 'youtube';
				videoInfo.params = videoInfo.params || {};
				$(btn).data('videoInfo', videoInfo);
			} else {
				console.log('Media not properly configured. Add "data-video" attribute with json info like "id" and "type"');
				return;
			}
		}
		var url, defaultParams;
		var options = {
			title: '',
			customDimensions: true,
			width: 640,
			height: 360,
			actionURI: false,
			modal: false
		};

		switch (videoInfo.type) {
			case 'youtube':
				url = '//www.youtube.com/embed/' + videoInfo.id;
				defaultParams = {
					autoplay: 1,
					mute: 0,
					fs: 0,
					rel: 0
				}
				break;
			case 'vimeo':
				url = '//player.vimeo.com/video/' + videoInfo.id;
				defaultParams = {
					autoplay: true,
					mute: 0
				}
				break;
			case 'kartra':
				url = `//app.kartra.com/video_front/portal_video/${videoInfo.id}`;
				defaultParams = {
					autoplay: true,
				}
				options.width = 850;
				options.height = 512;
				break;
			case 'mediaportal':
				options.actionURI = true;//this link is an internal one
				url = 'mediaportal.dashboard';
				defaultParams = {
				};
				options.customDimensions = false;
				options.hGap = 120;
				options.vGap = 60;
				break;
			default:
				break;
		}

		var params = $.extend({}, defaultParams, videoInfo.params);


		hrd.dashboard.openIFrameDialog(url, params, options, $.noop);
	},
	openLink: function(evt, btn) {
		var linkInfo = $(btn).data('linkInfo');
		if (linkInfo == undefined) {
			if ($(btn).data('link')) {
				linkInfo = $.evaluate($(btn).data('link'));
				linkInfo.uri = linkInfo.uri;
				$(btn).data('linkInfo', linkInfo);
			} else {
				console.log('LINK not properly configured. Add "data-link" attribute with json info like "uri" and "role"');
				return;
			}
		}

		hrd.utils.hpLink(linkInfo.uri);
	},
	/**
	 * METODHS Useful for Dashboard opened using 'OpenDashboard'
	 */
	setIFrameDialogTitle: function(title, customId) {
		hrd.dashboard.setIFrameDialogTitle(title, customId);
	},
	appendIFrameDialogTitle: function(suffix, customId) {
		hrd.dashboard.appendIFrameDialogTitle(suffix, customId);
	},
	/*****************************/
});